// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"9d7d5df5","246":"0db5e917","259":"48d89e68","488":"ae88e109","702":"8b986d0c","733":"f9400ecf","827":"efe2aff3","866":"338b2444"}[chunkId] + ".chunk.js";
};